export default __webpack_public_path__ + "static/media/bci-8-hover.c7760d33.svg";